import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { routes } from 'router'
import ModalProvider from 'shared/components/modalProvider'
import QueryProvider from 'shared/components/queryClient'
import Toaster from 'shared/components/toaster'
import './assets/scss/global.scss'

function App() {
  return (
    <>
      <QueryProvider>
        {(queryClient) => (
          <>
            <Suspense fallback={<div />}>
              <RouterProvider router={routes(queryClient)} />
            </Suspense>
            <Suspense fallback={<div />}>
              <ModalProvider />
            </Suspense>
            <Suspense>
              <Toaster />
            </Suspense>
          </>
        )}
      </QueryProvider>
    </>
  )
}

export default App
